import {Component, input, output, signal, viewChild, ElementRef, CUSTOM_ELEMENTS_SCHEMA, computed} from '@angular/core';

@Component({
  selector: 'app-file-drop-zone',
  templateUrl: './file-drop-zone.component.html',
  styleUrl: './file-drop-zone.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [],
})
export class FileDropZoneComponent {
  readonly accept = input<string[]>([]);
  readonly documentType = input.required<string>();

  readonly fileSelected = output<File | null>();

  protected readonly dragOver = signal(false);
  protected readonly selectedFile = signal<File | null>(null);
  protected readonly acceptList = computed(() => this.accept().join(', '));
  private readonly fileInput = viewChild.required<ElementRef<HTMLInputElement>>('fileInput');

  /** Clears the visible "selected file" state -- call after the caller has
   * finished acting on a previously emitted file (e.g. once an upload it
   * triggered has succeeded). */
  reset(): void {
    this.selectedFile.set(null);
    this.fileInput().nativeElement.value = '';
  }

  protected browse(): void {
    this.fileInput().nativeElement.click();
  }

  protected onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.dragOver.set(true);
  }

  protected onDragLeave(): void {
    this.dragOver.set(false);
  }

  protected onDrop(event: DragEvent): void {
    event.preventDefault();
    this.dragOver.set(false);
    const file = event.dataTransfer?.files[0];
    if (file) this.select(file);
  }

  protected onFileChange(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) this.select(file);
  }

  protected clear(event: Event): void {
    event.stopPropagation();
    this.reset();
    this.fileSelected.emit(null);
  }

  private select(file: File): void {
    this.selectedFile.set(file);
    this.fileSelected.emit(file);
  }
}
